import Big from "big.js";
import {toUS} from "@/utils/number.js";

/*
 * 数电发票--所有的红字、蓝字发票汇总信息
 */
export function useAllInvoice() {
    const initialData = ref({})
    const usageStatist = ref({})

    const allQaList = inject('provideAllQa');
    const currentQa = inject('provideCurrentQa');

    onMounted(() => {
        // 比当前题号小的、有发票的题----其他的数电题
        const otherDigitQaList = allQaList.value.filter(f => f.queType == '3' && f.queNo < currentQa.value.queNo &&
            ['31', '32', '33', '34', '35', '36', '37',].includes(f.sonQueType))
        let resList = []

        otherDigitQaList.forEach(ticket => {
            const sa = ticket.solution && JSON.parse(ticket.solution) || []
            const solutionArray = (Array.isArray(sa) ? sa : [sa]).map(m => {
                const obj = {
                    categoryCode: m.categoryCode,
                    invoiceStatus: m.status, // 发票状态
                    code: m.id, // 数电票号码
                    purchaseBuyName: m.buyer.name, // 购/销方名称
                    purchaseBuyCode: m.buyer.taxRegistrationNo,
                    taxAmount: m.totalTaxAmount, // 税额
                    Number_TaxAmount: parseFloat(m.totalTaxAmount),
                    totalAddedTaxAmount: m.totalAddedTaxAmount, // 价税合计
                    createTime: m.createTime, // 开票日期
                    queryType: '开具发票',
                    ticSource: '电子发票服务平台',
                    maker: '王云霞',
                    originTicData: {...m}, // 题目原始发票信息
                }
                if (m.addedTax) { // 价格为含税价
                    obj.amount = new Big(m.totalAmount).plus(m.totalTaxAmount * -1).toString()
                    obj.Number_amount = parseFloat(obj.amount)
                } else {
                    obj.amount = m.totalAmount
                    obj.Number_amount = parseFloat(m.totalAmount)
                }
                return obj
            })
            resList.push(...solutionArray)
        })
        console.log('取前面题发票数据结果', resList)
        initialData.value = resList

        // 以下为蓝字开票统计信息
        let blueAmount = new Big(0) // 蓝字发票开具金额
        let blueTax = new Big(0) // 蓝字累计税额
        let blueCount = 0 // 蓝字数量
        let totalAmount = new Big(400000)

        // 红字统计
        let redCount = 0
        let redAmount = new Big(0) // 红字发票开具金额
        let redTax = new Big(0) // 红字累计税额

        resList.forEach(tic => {
            if (tic.Number_amount >= 0) { // 蓝字发票
                blueCount ++
                blueAmount = blueAmount.plus(tic.Number_amount)
                blueTax = blueTax.plus(tic.Number_TaxAmount)
            } else {
                redCount++
                redAmount = redAmount.plus(tic.Number_amount)
                redTax = redTax.plus(tic.Number_TaxAmount)
            }
        })

        let remainAmount = totalAmount.minus(blueAmount).toString()
        usageStatist.value.totalCreditLimit = toUS(parseFloat(totalAmount.toString()), true) // 总授信额度
        usageStatist.value.remainAmount = toUS(parseFloat(remainAmount), true) // 剩余可用额度
        usageStatist.value.Number_remainAmount = parseFloat(remainAmount) // 剩余可用额度--Number
        usageStatist.value.blueCount = blueCount // 蓝字张数
        usageStatist.value.blueAmount = toUS(parseFloat(blueAmount), true) // 蓝字金额
        usageStatist.value.blueTax = toUS(parseFloat(blueTax), true) // 蓝字税额

        usageStatist.value.redAmount = toUS(parseFloat(redAmount), true) // 红字金额
        usageStatist.value.redCount = redCount // 红字张数
        usageStatist.value.redTax = toUS(parseFloat(redTax), true) // 红字税额
        console.log('前面的题目红字/蓝字统计信息', usageStatist.value)
    })

    return {
        initialData, // 前面题发票数据List
        usageStatist, // 额度使用统计信息
    }
}

export const categoryTypeList = [
    {
        label: '数电票(增值税专用发票)', value: '2',
    },
    {
        label: '数电票(普通发票)', value: '1',
    },
    {
        label: '数电票(机动车销售统一发票)', value: '4',
    },
    {
        label: '数电票(二手车销售统一发票)', value: '5',
    },
    {
        label: '数电纸质发票(增值税专用发票)', value: '6',
    },
    {
        label: '数电纸质发票(普通发票)', value: '7',
    },
    {
        label: '数电纸质发票(机动车销售统一发票)', value: '8',
    },
    {
        label: '数电纸质发票(二手车销售统一发票)', value: '9',
    },
    {
        label: '增值税电子专用发票', value: '15',
    },
    {
        label: '增值税电子普通发票', value: '17',
    },
    {
        label: '增值税专用发票', value: '14',
    },
    {
        label: '增值税普通发票', value: '16',
    },
    {
        label: '机动车销售统一发票', value: '12',
    },
    {
        label: '二手车销售统一发票', value: '13',
    },
    {
        label: '增值税普通发票(卷式)', value: '19',
    },
    {
        label: '道路通行费电子普通发票', value: '18',
    },
    {
        label: '数电票(航空运输电子客票行程单)', value: '10',
    },
    {
        label: '数电票(铁路电子客票)', value: '3',
    },
    {
        label: '数电票(通行费发票)', value: '11',
    },


]
